<template>
  <div id="enFooter">
    <div class="footer-info">
      <div class="footer-nav">
        <div class="brand-name">
          <a href="./">
            <img src="assets/images/logo_gray.png" alt="">
          </a>
        </div>
        <div class="footer-navbar">
          <ul class="nav navbar-nav">
            <li class="active"><a href="./products.html">PRODUCTS</a></li>
            <li><a href="./start.html">HOW TO START</a></li>
            <li><a href="./about.html">ABOUT US</a></li>
          </ul>
        </div>
      </div>
      <p>© 2017, Everonet, a subsidiary company of CardInfoLink. All rights reserved.</p>
      <p>沪 ICP 备 11004387 号</p>
    </div>
    <language-switch class="inverse"></language-switch>
    <!--<div class="language-switch">
      <ul>
        <li class="active">
          <a>En</a>
        </li>
        <li>
          <a>Jp</a>
        </li>
      </ul>
    </div>-->
  </div>
</template>
<script>
  import LanguageSwitch from './LanguageSwitch';

  export default {
    name: 'EnFooter',
    components: {
      LanguageSwitch
    },
  };
</script>
<style>
  #enFooter {
    background: #F6FAFB;
    padding: 42px 50px;
    display: flex;
    justify-content: space-between;
  }
  
  #enFooter>.footer-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  
  .footer-nav {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .footer-nav>.brand-name {
    margin-right: 18px;
  }
  
  #enFooter .navbar-nav>li {
    margin: 0 50px 0 0;
  }
  
  #enFooter .navbar-nav>li>a {
    color: #898c8f;
    font-size: 14px;
    line-height: 14px;
    padding: 0;
  }
  
  #enFooter p {
    margin: 0;
    color: #898c8f;
    font-size: 14px;
  }
  
  #enFooter>.language-switch>ul>li {
    list-style: none;
    float: left;
    margin-left: 8px;
  }
  
  #enFooter>.language-switch>ul>li>a {
    text-decoration: none;
    background: #898c8f;
    color: #FFF;
    border: 2px solid #898c8f;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    line-height: 35px;
    text-align: center;
    cursor: pointer;
  }
  
  #enFooter>.language-switch>ul>li.active>a {
    color: #898c8f;
    background: #FFF;
  }
</style>


// WEBPACK FOOTER //
// EnFooter.vue?0ba7c7c0